// export async function getCourses() {
//   const baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
//   const res = await fetch(
//     `${baseURL}/api/courses/course/getall`
//   );

//   if (!res.ok) throw new Error("Failed to fetch courses data");

//   const data = await res.json();
//   return data.slice(4);
// }


// export async function getCourses() {
//   try {
//     const baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
//     const res = await fetch(`${baseURL}/api/courses/course/getall`);

//     if (!res.ok) {
//       console.error("API responded with status:", res.status);
//       return [];
//     }

//     const data = await res.json();
//     return data.slice(4);
//   } catch (error) {
//     console.error("Failed to fetch courses data:", error.message);
//     return [];
//   }
// }

function fetchWithTimeout(url, options = {}, timeout = 2000) {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), timeout)
    ),
  ]);
}

export async function getCourses(retries = 1) {
  const baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
  const url = `${baseURL}/courses/course/getall`;

  for (let attempt = 1; attempt <= retries + 1; attempt++) {
    try {
      const res = await fetchWithTimeout(url, {}, 2000);

      if (!res.ok) {
        console.error(`Attempt ${attempt}: API error status ${res.status}`);
        continue;
      }

      const data = await res.json();

      if (!Array.isArray(data)) {
        console.error("Invalid data format from API:", data);
      }

      return data;
    } catch (error) {
      console.error(`Attempt ${attempt}: ${error.message}`);
    }
  }

  return [];
}